module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-celery.fd73a07e.svg";